import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getVideos } from '../../redux/modules/video';
import {
  getIsMultiUser,
  getOrganizations,
  getOwnedOrganizationState,
  getSelectedOrganization,
  selectOrganization
} from '../../redux/modules/organization';
import styles from './OrganizationMenu.module.less';

const PERSONAL_CONTEXT_LABEL = 'My Account';

const isSameOrganization = (firstOrgId, secondOrgId) => {
  if (!firstOrgId && !secondOrgId) {
    return true;
  }

  if (firstOrgId === secondOrgId) {
    return true;
  }

  return false;
};

function getActiveClassOrNull(organizationId, selectedOrganizationId) {
  return isSameOrganization(organizationId, selectedOrganizationId) ? styles.vpActiveLink : '';
}

// this component appears only on mobile
const OrganizationMenu = ({
  _getVideos,
  _selectOrganization,
  isMultiUser,
  memberOrganizations,
  selectedOrganization
}) => {
  if (!isMultiUser) {
    return null;
  }

  const switchContextAndGetVideos = (organizationId) => {
    if (organizationId === selectedOrganization?.organization?.id) {
      return;
    }
    _getVideos();
    _selectOrganization(organizationId, true);
  };

  return (
    <section>
      {memberOrganizations.map((organizationDetails, idx) => (
        <React.Fragment key={idx}>
          {organizationDetails.role.name}
          <h4
            key={organizationDetails.organization.id}
            className={`${styles.vpDrawerLink} ${getActiveClassOrNull(
              organizationDetails.organization.id,
              selectedOrganization?.organization?.id
            )}`}
            onClick={() => switchContextAndGetVideos(organizationDetails.organization.id)}>
            {`${organizationDetails.organization.name}${
              organizationDetails.role ? ' (Shared)' : ''
            }`}
          </h4>
        </React.Fragment>
      ))}
      <h4
        className={`${styles.vpDrawerLink} ${getActiveClassOrNull(null, selectedOrganization?.organization?.id)}`}
        onClick={() => switchContextAndGetVideos(null)}>
        {PERSONAL_CONTEXT_LABEL}
      </h4>
    </section>
  );
};

OrganizationMenu.propTypes = {
  _getVideos: PropTypes.func,
  _selectOrganization: PropTypes.func,
  isMultiUser: PropTypes.bool,
  memberOrganizations: PropTypes.array,
  selectedOrganization: PropTypes.object,
  ownedOrganization: PropTypes.object
};

function mapStateToProps(state) {
  return {
    isMultiUser: getIsMultiUser(state),
    memberOrganizations: getOrganizations(state),
    selectedOrganization: getSelectedOrganization(state),
    ownedOrganization: getOwnedOrganizationState(state)
  };
}

const mapDispatchToProps = {
  _getVideos: getVideos,
  _selectOrganization: selectOrganization
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationMenu);



// WEBPACK FOOTER //
// ./src/components/Header/OrganizationMenu.jsx